import React from 'react';
import dynamic from 'next/dynamic';

import { ProductPageTemplate } from 'src/templates';
import { ProductPageHeader } from 'src/components/headers/ProductPageHeader';
import Features from 'src/components/features';
import Showcase from 'src/components/showcase';
import Quote from 'src/components/quote';
import FooterExtension from 'src/components/footer-extension';

import { Locales } from 'src/lib/constants';

// data
import {
  metaData,
  productHeaderData,
  featuresData,
  interactiveData,
  showcaseData,
  quoteData,
  footerExtensionData,
} from 'src/store/en-eu/products/assets';

const InteractiveData = dynamic(
  () => {
    return import('src/components/Surfaces/InteractiveData/InteractiveData');
  },
  {
    ssr: false,
  },
);

const EUProductAssets = ({ locale = Locales.EN_EU }) => {
  return (
    <ProductPageTemplate
      fields={{ components: [], ...metaData }}
      locale={locale}
    >
      <ProductPageHeader {...productHeaderData} />
      <Features {...featuresData} />
      <InteractiveData {...interactiveData} />
      <Showcase {...showcaseData} />
      <Quote {...quoteData} />
      <FooterExtension {...footerExtensionData} />
    </ProductPageTemplate>
  );
};

export default EUProductAssets;
